import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { ClientVm } from './client.vm';

export class GetClientsVm extends PageResponseVm<ClientVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => ClientVm)
  @ValidateNested({ each: true })
  objects: ClientVm[];
}
